import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as Tokens from '@shared/core/tokens';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddressProviderMapper } from '@shared/core/mappers/address-provider.shared.mapper';

@Injectable({
    providedIn: 'root',
})
export class AddressProviderService {
    constructor(@Inject(Tokens.CONFIG_TOKEN) public config: OLO.Config, public httpClient: HttpClient) {}
    private _addressProviderUrl: string = 'addressProvider';

    public validate(provider: OLO.Enums.ADDRESS_PROVIDER, addressId: number): Observable<OLO.DTO.ValidateAddressResult> {
        return this.httpClient
            .post<APIv3.ValidateAddressResult>(`${this.config.api.base}/${this._addressProviderUrl}/validate`, {
                Provider: provider,
                AddressId: addressId,
            })
            .pipe(map((response: APIv3.ValidateAddressResult) => AddressProviderMapper.mapValidatePOSTResponse(response)));
    }

    public autocomplete(provider: OLO.Enums.ADDRESS_PROVIDER, query: string): Observable<OLO.DTO.AddressSugestionsDto> {
        return this.httpClient
            .post<APIv3.AddressSugestionsDto>(`${this.config.api.base}/${this._addressProviderUrl}/autocomplete`, {
                Provider: provider,
                Query: query,
            })
            .pipe(map((response: APIv3.AddressSugestionsDto) => AddressProviderMapper.mapAddressSugesstionsPOSTResponse(response)));
    }

    public reverseGeocoding(provider: OLO.Enums.ADDRESS_PROVIDER, geolocation: OLO.DTO.GeolocationDto): Observable<OLO.DTO.AddressSugestionsDto> {
        return this.httpClient
            .post<APIv3.AddressSugestionsDto>(`${this.config.api.base}/${this._addressProviderUrl}/reverseGeocoding`, {
                Provider: provider,
                Geolocation: geolocation,
            })
            .pipe(map((response: APIv3.AddressSugestionsDto) => AddressProviderMapper.mapAddressSugesstionsPOSTResponse(response)));
    }
}
